function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.782 23.904c.78-.63 1.492-1.341 2.122-2.122l6.657 6.657a1.5 1.5 0 0 1-2.122 2.122l-6.657-6.657zM13 25C6.373 25 1 19.627 1 13S6.373 1 13 1s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S18.523 3 13 3 3 7.477 3 13s4.477 10 10 10z"
});

var SvgSearch = function SvgSearch(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "0f1fb97d1f3993e058864b3106d7785f.svg";
export { SvgSearch as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/search.svg
// module id = null
// module chunks = 